import { CommonModule } from '@angular/common';
import { Component, ViewChild, output } from '@angular/core';
import { PopoverComponent } from 'src/app/@core/components/ui/popover/popover.component';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';
import { GENERAL_AGENT_SVG } from 'src/app/common/svgs';
import { SanitizeHtmlPipe } from 'src/app/@shared/pipes/sanitizeHtml.pipe';

@Component({
    selector: 'app-prompt-library-walkthrough',
    standalone: true,
    imports: [CommonModule, PopoverComponent, ButtonComponent, SanitizeHtmlPipe],
    templateUrl: './prompt-library-walkthrough.component.html',
})
export class PromptLibraryWalkthroughComponent {
    readonly GENERAL_AGENT_SVG = GENERAL_AGENT_SVG;
    gotIt = output<void>();
    checkPrompts = output<void>();
    dismissed = output<void>();

    @ViewChild('popover') private popoverRef!: PopoverComponent;
    private _closedIntentionally = false;

    show(sidebarEl: HTMLElement, desiredTop = 400): void {
        const r = sidebarEl.getBoundingClientRect();
        // placement="right" anchors to originY:'center', so shift top so center lands at desiredTop
        const anchorTop = desiredTop - r.height / 2;
        const anchor = document.createElement('div');
        anchor.style.cssText = `position:fixed;top:${anchorTop}px;left:${r.left}px;width:${r.width}px;height:${r.height}px;pointer-events:none;`;
        document.body.appendChild(anchor);
        this.popoverRef.show(null, anchor);
        setTimeout(() => document.body.removeChild(anchor), 500);
    }

    hide(): void {
        this._closedIntentionally = true;
        this.popoverRef.hide();
    }

    onVisibleChange(visible: boolean): void {
        if (!visible) {
            if (this._closedIntentionally) {
                this._closedIntentionally = false;
            } else {
                this.dismissed.emit();
            }
        }
    }

    onGotIt(): void {
        this.gotIt.emit();
    }

    onCheckPrompts(): void {
        this.checkPrompts.emit();
    }
}
